import {
  getDict,
  getNativePlace,
  queryCategoryList,
  queryDictTreeByCode,
  queryFamily2List,
  queryFamilyList,
  queryPolicyList,
  queryZybgZyList,
} from '../https/common'
import {
  Cascader,
  Select,
  SmartTreeSelectByPopup,
} from './baseComponentConfig'

export class FamilySelect extends Select {
  value = 'jtcydm'
  label = '家庭成员'
  required = true
  valueName='key'
  labelFormat='{value}'
  apiMethod = queryFamilyList
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

export class Family2Select extends Select {
  value = 'jtcydm'
  label = '家庭成员'
  required = true
  valueName='key'
  labelFormat='{value}'
  apiMethod = queryFamily2List
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

export class PolicySelect extends Select {
  value = 'gbzydm'
  label = '政治面貌'
  required = true
  valueName='key'
  labelFormat='{value}'
  apiMethod = queryPolicyList
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
export class CategorySelect extends Select {
  value = 'xbkldm'
  label = '科类'
  required = true
  valueName='key'
  labelFormat= '{value}'
  apiMethod = queryCategoryList
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

// 行政区划
export class AllPlaceCasceder extends Cascader {
  value = 'hkszdCode'
  remote = true
  tree = true
  apiMethod = getNativePlace
  params = { dictCode: 'xzqh' }
  dataPath='data'
  remoteParams = { 'childrenCode': '' }
  changeOnSelect = true
  renderFormat=(label) => label.join('')
  required = true
  label = '户口所在地'
  constructor (option) {
    super()
    this.mergeOptions(option)
  }
}
export class AllPlaceSelect extends SmartTreeSelectByPopup {
  value = 'hkszdCode'
  toLink = true
  label='户口所在地'
  params = { dictCode: 'xzqh' }
  required = true
  remoteParams= { dictCode: 'xzqh' }
  dynamicLoadParams= { dictCode: 'xzqh' }
  dynamicLoadMethod = getDict
  remoteMethod= queryDictTreeByCode
  constructor (option) {
    super()
    this.mergeOptions(option)
  }
}

// 生源地区-老师
export class StudentsInArea extends Select {
  value = 'sydqWid'
  params = {}
  dataPath='data'
  required = true
  label = '所属招生地区'
  constructor (option) {
    super()
    this.mergeOptions(option)
  }
}
export class ChangeMajorSelect extends Select {
  value = 'zybgdm'
  label = '变更专业'
  required = true
  valueName='key'
  labelFormat= '{value}'
  apiMethod = queryZybgZyList
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
